import { render, staticRenderFns } from "./ReportIndex.vue?vue&type=template&id=5d32f37e&scoped=true&"
import script from "./ReportIndex.vue?vue&type=script&lang=ts&"
export * from "./ReportIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d32f37e",
  null
  
)

export default component.exports